import {DefaultDeliveryFlow, DefaultTimelineMetadata} from "../../../../util/types";
import {findMetadata} from "../../../../util/helpers";
import {CardList} from "./Card/Card";
import OrderConfirmedCard from "./Card/OrderConfirmedCard";
import OnlineCard from "./Card/OnlineCard";
import CpeCard from "./Card/CpeCard";
import {ContractorCard} from "./Card/ContractorCard";
import {TechnicianOnlineCard} from "./Card/TechnicianCard";
import OntCard from "./Card/OntCard";

export default function TdcFbsaTimeline({deliveryFlow}: { deliveryFlow: DefaultDeliveryFlow }) {
    const metadata: DefaultTimelineMetadata[] = deliveryFlow.timeline_metadata;
    const should_receive_ont = findMetadata('should_receive_ont', metadata);
    const contractor = findMetadata('contractor', metadata);
    const technician = findMetadata('technician', metadata);
    const has_digging_code_discrepancy = findMetadata('has_status_digging_code_discrepancy', metadata);
    const is_gds_expected = findMetadata('is_gds_expected', metadata);
    const send_hardware = findMetadata('send_hardware', metadata);

    const gds_expected_with_discrepancy = has_digging_code_discrepancy && is_gds_expected;

    return <CardList>
        <OrderConfirmedCard metadata={metadata}/>
        {send_hardware && <CpeCard metadata={metadata}/>}
        {should_receive_ont && <OntCard metadata={metadata}/>}
        {contractor && !gds_expected_with_discrepancy && <ContractorCard metadata={metadata} timeline_type={deliveryFlow.timeline_info.timeline_type}/>}
        {technician && !gds_expected_with_discrepancy ? <TechnicianOnlineCard metadata={metadata}/> : <OnlineCard metadata={metadata}/>}
    </CardList>
}
